import React from 'react'


const Hero = () => {
  return (
    <div className='h-fit w-full lg:h-[100vh] bg-[#eeeeee] w-full ' >
      <div className='bg-our-approach-hero h-[80vh] lg:h-[100vh] w-full lg:w-[100%] lg:m-auto bg-cover bg-center flex lg:py-0' >
          <h3 className='pt-16 md:pt-[20vh] lg:pt-32 text-5xl w-[70%] lg:w-[50%] relative left-[30%] lg:left-[45%] font-mosk600 text-[#2591fd]' >What we bring <br /> to the table for you...</h3>
      </div>
    </div>
  )
}

export default Hero
